import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { goToLogin } from '../../../../api/auth';
import { Link } from '../../../../components/Link';
import { Thumbnail } from '../../../../components/thumbnail/thumbnail';
import { SvgCart, SvgPlayCircle } from '../../../../icons';
import { EpisodeAsset } from '../../../../queries/ats/titles/types/asset';
import { VodSource } from '../../../../queries/ats/titles/types/sources';
import { isBookmarkedSource } from '../../../../queries/ats/titles/utils/sources-utils';
import { routes } from '../../../../routes/route-utils';
import { useAuth } from '../../../../utils/auth-utils';
import { getPercent } from '../../../../utils/commonUtils';
import { PurchaseProductModal } from '../../purchase-product-modal/purchase-product-modal';
import { useDetailsImage } from '../../use-details-image';
import { BookmarkedThumbnail } from './bookmarked-thumbnail';
import styles from './episode.module.scss';

interface EpisodeThumbnailVodProps {
  episode: EpisodeAsset;
  source: VodSource;
}

export function EpisodeVodThumbnail({ episode, source }: EpisodeThumbnailVodProps) {
  const { t } = useTranslation();
  const [isTransactionModalOpen, setIsTransactionModalOpen] = useState(false);
  const isOwned = source.product.status === 'purchased' || source.product.status === 'rented';
  const { loggedInWithCredentials: isAuth } = useAuth();

  const src = useDetailsImage({ asset: episode, shape: 'wide', width: 200 });

  const image = {
    src: src,
    alt: `${episode.titleName} cover`,
  };

  const progress =
    source.bookmark !== undefined && episode.duration
      ? getPercent(source.bookmark.position, episode.duration)
      : undefined;

  if (!isOwned) {
    return (
      <button
        className={styles.thumbnailButton}
        onClick={(event) => {
          event.preventDefault();
          if (isAuth) {
            setIsTransactionModalOpen((open) => !open);
          } else {
            goToLogin();
          }
        }}
      >
        {isAuth ? (
          <PurchaseProductModal
            asset={episode}
            source={source}
            isOpen={isTransactionModalOpen}
            onClose={() => setIsTransactionModalOpen(false)}
          />
        ) : null}

        <Thumbnail image={image} icon={SvgCart} iconText={t('buy or rent')} progress={progress} />
      </button>
    );
  }

  if (isBookmarkedSource(source)) {
    return <BookmarkedThumbnail episode={episode} source={source} image={image} />;
  }

  return (
    <Link
      to={routes.play({
        platformTitleId: source.platformTitleId,
        providerIdentifier: source.providerIdentifier,
        masterId: episode.masterId,
      })}
    >
      <Thumbnail image={image} icon={SvgPlayCircle} />
    </Link>
  );
}
